import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE_CONFIGURACAO_IDIOMA = 'ConfiguracaoIdioma';

export const salvarConfiguracaoIdiomaAsync = async (
  idioma: ConfiguracoesIdiomasTipo
) => {
  await AsyncStorage.setItem(CHAVE_CONFIGURACAO_IDIOMA, JSON.stringify(idioma));
};

export const carregarConfiguracaoIdiomaAsync = async () => {
  const idiomaJson = await AsyncStorage.getItem(CHAVE_CONFIGURACAO_IDIOMA);

  const idioma = idiomaJson
    ? (JSON.parse(idiomaJson) as ConfiguracoesIdiomasTipo)
    : ConfiguracoesIdiomasTipo.PadraoSistema;

  return idioma;
};

export enum ConfiguracoesIdiomasTipo {
  PadraoSistema = 'system',
  Portugues = 'pt',
  Ingles = 'en',
  Espanhol = 'es'
}
